const Value = () => {
  return (
    <section className="bg-secondary/40 py-12 lg:py-14">
      <div className="container-tight">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="eyebrow">Value</span>
            <h2 className="mt-4 text-4xl font-semibold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              AI is easy. <span className="font-serif italic text-muted-foreground">ROI isn't.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-lg leading-relaxed text-muted-foreground">
              Which is why the starting point needs to be <span className="font-medium text-foreground">low-risk, but high clarity</span>. Signal AI is built specifically for that moment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Value;
